<div (swipeRight)="onSwipeRight($event)" (swipeLeft)="onSwipeLeft($event)">
    <mwl-calendar-month-view (dayClicked)="eventClicked($event)" [viewDate]="viewDate" [events]="events" [cellTemplate]="customCellTemplate">
    </mwl-calendar-month-view>
</div>

<ng-template #customCellTemplate
             let-day="day"
             let-locale="locale">
  <div class="cal-cell-top">
    <span class="cal-day-number"
          [ngClass]="{'active': isSelected(day.date)}">
        {{ day.date | calendarDate:'monthViewDayNumber':locale }}</span>
  </div>
  <div  *ngIf="day.events.length"
        class="cal-events">
    <div class="cal-event flaggedCalEvent"></div>
  </div>
</ng-template>
